import React from 'react';
import { BookOpen } from 'lucide-react';
export function ExpertEndorsement() {
  return <section className="py-20 bg-black" data-id="element-166">
      <div className="max-w-6xl mx-auto px-4" data-id="element-167">
        <div className="relative border border-gold-500/30 rounded-3xl overflow-hidden" data-id="element-168">
          {/* Background glow */}
          <div className="absolute top-0 left-0 w-full h-full bg-gold-500/5" data-id="element-169"></div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-170">
            {/* Author Image - Image 2 */}
            <div className="order-2 lg:order-1 p-8 lg:p-0" data-id="element-171">
              <img src="https://cdn.magicpatterns.com/uploads/rfi5uuTrfwMNn2MGKqBuxi/2_Focused_productivity_at_sunset.png" alt="José Alejandro Flores - Autor" className="w-full h-auto rounded-2xl lg:rounded-none lg:rounded-l-3xl" data-id="element-172" />
            </div>

            {/* Author Content */}
            <div className="order-1 lg:order-2 p-8 md:p-12" data-id="element-173">
              <div className="flex items-center gap-3 mb-8" data-id="element-174">
                <BookOpen className="w-8 h-8 text-gold-500" data-id="element-175" />
                <h3 className="text-2xl font-serif font-bold text-gold-500" data-id="element-176">
                  Este método no está hecho para motivarte
                </h3>
              </div>

              <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-177">
                <p className="text-xl text-white font-medium" data-id="element-178">
                  Está hecho para funcionar.
                </p>

                <p data-id="element-179">
                  Esto no es teoría ni frases bonitas. Es un sistema pensado
                  para el mundo real: urgencias, mensajes constantes, reuniones
                  que se alargan, notificaciones y cero espacio mental.
                </p>

                <p data-id="element-180">
                  Porque el caos laboral no se resuelve con fuerza de voluntad.
                  Se resuelve con{' '}
                  <span className="text-white font-medium" data-id="element-181">
                    estructura clara, decisiones simples y un método que puedas
                    usar incluso en días saturados
                  </span>
                  .
                </p>

                <p className="text-xl font-serif italic text-gold-500 border-l-4 border-gold-500 pl-6 py-2" data-id="element-182">
                  Menos ruido. Más control. Acción concreta.
                </p>

                <p className="text-lg text-gray-400" data-id="element-183">
                  Porque el caos laboral no se arregla con ganas. Se arregla con
                  estructura.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}